'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const AndroidIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.99585 7.99792C9.99585 8.54906 9.54906 8.99585 8.99792 8.99585C8.44679 8.99585 8 8.54906 8 7.99792C8 7.44679 8.44679 7 8.99792 7C9.54906 7 9.99585 7.44679 9.99585 7.99792Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.9958 7.99792C15.9958 8.54906 15.5491 8.99585 14.9979 8.99585C14.4468 8.99585 14 8.54906 14 7.99792C14 7.44679 14.4468 7 14.9979 7C15.5491 7 15.9958 7.44679 15.9958 7.99792Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4 12V11.25H3.25V12H4ZM20 12H20.75V11.25H20V12ZM20 21V21.75C20.4142 21.75 20.75 21.4142 20.75 21H20ZM4 21H3.25C3.25 21.4142 3.58579 21.75 4 21.75V21ZM4 12.75H20V11.25H4V12.75ZM19.25 12V21H20.75V12H19.25ZM20 20.25H4V21.75H20V20.25ZM4.75 21V12H3.25V21H4.75ZM4.75 11C4.75 6.99594 7.99594 3.75 12 3.75V2.25C7.16751 2.25 3.25 6.16751 3.25 11H4.75ZM12 3.75C16.0041 3.75 19.25 6.99594 19.25 11H20.75C20.75 6.16751 16.8325 2.25 12 2.25V3.75ZM4.80613 11.9072C4.76911 11.6103 4.75 11.3076 4.75 11H3.25C3.25 11.3698 3.27298 11.7345 3.31766 12.0928L4.80613 11.9072ZM19.25 11C19.25 11.3076 19.2309 11.6103 19.1939 11.9072L20.6823 12.0928C20.727 11.7345 20.75 11.3698 20.75 11H19.25ZM6.75032 4.69117L4.75031 2.69111L3.68963 3.75176L5.68964 5.75181L6.75032 4.69117ZM19.2324 2.70735L17.2324 4.70736L18.293 5.76803L20.2931 3.76802L19.2324 2.70735Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpAndroidIcon = forwardRef(AndroidIcon);

export { VpAndroidIcon as default };
